import React from "react";
// import logo from './logo.svg';
import "./InitialFooter.scss";

const InitialFooter = (props) => {
  return (
        <div className="footer" style={props.style}>
          <img src={props.logo} alt="GE HealthCare" className="logo" />
          <p className="footer-text">
          {props.children}
          </p>
        </div>
  );
};
export default InitialFooter;
